import { render } from "./jiufangEsports.vue?vue&type=template&id=054a3e84&scoped=true"
import script from "./jiufangEsports.vue?vue&type=script&lang=js"
export * from "./jiufangEsports.vue?vue&type=script&lang=js"

import "./jiufangEsports.vue?vue&type=style&index=0&id=054a3e84&scoped=true&lang=css"

import exportComponent from "/Users/liusx/Projects/pc-web-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054a3e84"]])

export default __exports__